import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";
import { formatDataForDataTable } from "../../utils/formatData";

const initialState = {
  loading: false,
  qrCodeData: [],
};

export const getAllQrcodes = createAsyncThunk(
  "qrCodes/getAllQrcodes",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `qr-codes`,
    });

    return res;
  }
);

export const createQrCode = createAsyncThunk(
  "qrCodes/createQrCode",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `qr-codes`,
      data: data,
    });

    return res;
  }
);

export const deleteQrCode = createAsyncThunk(
  "qrCodes/deleteQrCode",
  async ({ id }) => {
    const res = await apiRequest({
      method: "delete",
      url: `qr-codes/${id}`,
    });

    return res;
  }
);

export const dowloadQrCode = createAsyncThunk(
  "qrCodes/dowloadQrCode",
  async (id) => {
    const res = await apiRequest({
      method: "get",
      url: `qr-codes/download/${id}`,
      responseType: "blob", // 🔑 important
    });

    return res; // this will be a Blob, not JSON
  }
);

const qrCodeSlice = createSlice({
  name: "qrCodes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //.................GET FOODLIST..............................
    builder.addCase(getAllQrcodes.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllQrcodes.fulfilled, (state, action) => {
      const data = formatDataForDataTable(action.payload.data);
      return {
        ...state,
        loading: false,
        qrCodeData: data,
      };
    });
    // ---------------------createQrCode---------------------------
    builder.addCase(createQrCode.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(createQrCode.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------deleteQrCode----------------------------
    builder.addCase(deleteQrCode.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteQrCode.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------dowloadQrCode---------------------------
    builder.addCase(dowloadQrCode.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(dowloadQrCode.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});
export default qrCodeSlice.reducer;
